
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-prototype-builtins */
import Component from 'vue-class-component';
import { Auth, CognitoUser } from '@aws-amplify/auth';
import { Hub } from '@aws-amplify/core';
import UpdateMixIn from './mixins/update';
import MqttMixIn from './mixins/mqttManagement';
import container from './app.container';
import { Group } from '@/flightpath-components/models/CognitoUser';
import { ConvertMachineKey, MachineKey } from '@/flightpath-components/models/MachineKey';
import { AlarmModel, Convert } from '@/flightpath-components/models/AlarmModel';
import { FlightPathServiceInterface } from '@/flightpath-components/services/FlightPathServiceInterface';
import SERVICE_IDENTIFIER from '@/flightpath-components/services/identifiers';
import { getModule } from 'vuex-module-decorators';
import AlarmStore from '@/store/modules/alarms';
import MenuStore from '@/store/modules/menu';
import MissionStore from '@/store/modules/missions';
import FieldStore from '@/store/modules/fields';
import { Mixins, Watch } from 'vue-property-decorator';
import MachineStore from './store/modules/machine';
import { PubSub } from './PubSubClass';
import { SinglePathMission } from '@/flightpath-components/models/SinglePathMission';
import { Point } from '@/flightpath-components/models/Point';
import { GPSLocation } from '@/flightpath-components/models/GPSLocation';
import { ConvertMissionStatus, MissionStatusAutoTransitionMessage } from '@/flightpath-components/models/mqttPayload/MissionStatusAutoTransitionMessage';
import router from './router';
import { DeployedSinglePathMission } from '@/flightpath-components/models/DeployedSinglePathMission';
import { MachineMarker } from '@/flightpath-components/models/mqttPayload/MachineMarkerMessage';
import { MenuState } from '@/flightpath-components/models/enums/Menu';
import NotificationStore from './store/modules/notifications';
import NotificationMixIn from './mixins/notifications';
import MachineUpdateMixIn from './mixins/softwareUpdate';
import { Convert as GenericNotifyConvert } from '@/flightpath-components/models/mqttPayload/GenericNotificationMessage';
import { ImplementKeys, Parameters } from './services/Parameters';
import { ImplementOperationsModel } from '@/flightpath-components/models/implement/ImplementOperationsModel';
import MissionToolTypes from './services/MissionToolTypes';
import TinyCon from 'tinycon';
import { Entities } from '@/models/Entities';
import GlobalStore from '@/store/modules/global';
import { MachineSWUpdateData } from '@/models/MachineSWUpdateData';
import { UISWUpdateData } from '@/models/UISWUpdateData';
import { MachineSoftwareUpdateState } from './models/MachineSoftwareUpdateState';
import UpdateStore from './store/modules/update';
import { UserProceedWithUpdateResponse } from './models/UserProceedWithUpdateResponse';
import { AvailableUpdateStatus } from './models/AvailableUpdateStatus';
import { toNumber } from 'lodash';
import MachineEngineInfo from './components/Machine/MachineEngineInfo.vue';
import H2MachineEngineInfo from './components/Machine/H2MachineEngineInfo.vue';
import { h2Account } from './accounts';
import { SortHelper } from './services/SortHelper';
import { FieldOperationsModel } from './flightpath-components/models/FieldOperationsModel';
import { Guid } from 'guid-typescript';
import { getThemeName } from '@/themes';
const EntitesList = ['Field', 'SimplePath', 'DeployedSinglePathMission'];

// Theme-aware logo assets
const themeName = getThemeName();
// eslint-disable-next-line @typescript-eslint/no-var-requires
const themeLogo = require(`@/themes/assets/${themeName}/logo.svg`);
// eslint-disable-next-line @typescript-eslint/no-var-requires
const themeLogo24 = require(`@/themes/assets/${themeName}/logo-24.svg`);
// eslint-disable-next-line @typescript-eslint/no-var-requires
const themeGroupe24 = require(`@/themes/assets/${themeName}/groupe-24.svg`);
// eslint-disable-next-line @typescript-eslint/no-var-requires
const themeAgriculture24 = require(`@/themes/assets/${themeName}/agriculture-24.svg`);

@Component({ name: 'App', provide: { container: container }, components: { MachineEngineInfo, H2MachineEngineInfo } })
export default class App extends Mixins(MqttMixIn, UpdateMixIn, NotificationMixIn, MachineUpdateMixIn) {
  // Theme-aware logos
  themeLogo = themeLogo;
  themeLogo24 = themeLogo24;
  themeGroupe24 = themeGroupe24;
  themeAgriculture24 = themeAgriculture24;

  globalStore = getModule(GlobalStore, this.$store);
  menuStore = getModule(MenuStore, this.$store);
  machineStore = getModule(MachineStore, this.$store);
  alarmStore = getModule(AlarmStore, this.$store);
  updateStore = getModule(UpdateStore, this.$store);
  missionStore = getModule(MissionStore, this.$store);
  fieldStore = getModule(FieldStore, this.$store);
  notificationStore = getModule(NotificationStore, this.$store);
  signedIn = false;
  updateDialog = false;
  private flightPathService: FlightPathServiceInterface | undefined = undefined;
  mini = true;
  user: CognitoUser | undefined;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  userInfo: any = {};
  allowManagerViews = false;
  allowOperatorViews = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  items: any = [];
  loadingAlarms = false;
  paramDialog = false;
  engineInfoDialog = false;
  editParam = true;
  missionTypes = MissionToolTypes.missionTypes;
  selectedMissionType = ImplementKeys.tillage;
  toolTypes = MissionToolTypes.toolTypes;
  implements: ImplementOperationsModel[] = [];
  missionParamFormValid = false;
  selectedToolType = '';
  vineWidth = 0;
  volume = 0;
  sprayProduct = '';
  speedKph = 0;
  speedRpm = 0;
  selectedMachineMissionStatus: MissionStatusAutoTransitionMessage | null = null;
  isOnline = false;
  availableFields: FieldOperationsModel[] = [];
  customerDeployedMissions: DeployedSinglePathMission[] = [];
  selectedDeployedMission: DeployedSinglePathMission | null = null;
  isWakeLockSupported = false;
  // eslint-disable-next-line no-undef
  wakeLock: WakeLockSentinel | null = null;
  warmLambdaInterval: number | undefined = undefined;
  pathPlanningUrl: string = process.env.VUE_APP_PATH_PLANNING_URL || "https://traxx-pathplanning.exxact-robotics.com/";

  get drawerState() {
    return this.menuStore.drawer;
  }
  set drawerState(value: boolean) {
    this.menuStore.setDrawer(value);
  }

  @Watch('notificationStore.totalNotifications', { deep: true, immediate: true })
  onNotificationChange(value: any): void {
    TinyCon.setBubble(this.notificationStore.totalNotifications);
  }

  @Watch('$vuetify.breakpoint.name')
  onBreakPointChange(name: string): void {
    this.setMenu();
  }

  @Watch('missionStore.editMode')
  onEditModeChange(value: boolean) {
    if (value) this.paramDialog = true;
  }

  @Watch('menuStore.currentMenuState')
  onMenuStateChanged(value: string) {
    if (value == MenuState.MachineSelected && this.machineStore.machine != null) {
      const machine = this.machineStore.machine;
      this.checkMachineState(machine);
    }
  }
  @Watch('machineStore.machine')
  onMachineChanged(value: MachineKey) {
    if (this.menuStore.currentMenuState == MenuState.MachineSelected && value != null) {
      const machine = value;
      this.checkMachineState(machine);
    }
  }
  get selectedMission(): number | null {
    return this.missionStore.selectedMissionIndex;
  }
  set selectedMission(value: number | null) {
    if (value != null && value == this.missionStore.selectedMissionIndex) this.missionStore.setSelectedMissionIndex(null);
    else this.missionStore.setSelectedMissionIndex(value as number);
  }

  popState() {
    this.menuStore.popMenuState();
  }
  pushMachineState() {
    this.menuStore.pushMenuState('Machines');
  }

  get currentRouteName(): string {
    return this.$route.meta?.title ?? '';
  }
  get selectedItem(): number | null {
    return this.machineStore.selectedMachineIndex;
  }
  set selectedItem(value: number | null) {
    this.machineStore.setSelectedMachineIndex(value as number);
  }

  get currentMenuTitle(): string {
    const stateName = this.menuStore.currentMenuState.replace('-', ' ');
    switch (this.menuStore.currentMenuState) {
      case 'Machine-Selected':
        return 'Machine ' + this.machineStore.selectedMachine?.MachineName;
      case 'Select-Mission':
        return this.$t('menu.select_mission').toString();
      default:
        return stateName;
    }
  }
  get speedLabel(): string {
    return this.speedKph + 'km/h';
  }

  get isH2Machine(): boolean {
    return this.globalStore.accountId === h2Account;
  }

  async getDeployedMissions(): Promise<DeployedSinglePathMission[]> {
    if (this.flightPathService != null) {
      const deployedMissionResponse = await this.flightPathService.getActiveDeployedSinglePathMissions(this.globalStore.accountId);
      if (deployedMissionResponse != null) {
        return DeployedSinglePathMission.toModelCollection(JSON.stringify(deployedMissionResponse.data));
      } else return [];
    }
    return [];
  }

  async getAvailableFields() {
    if (!this.flightPathService) return;

    const response = await this.flightPathService.getAvailableFields(this.globalStore.accountId);
    this.availableFields = FieldOperationsModel.toModelCollection(JSON.stringify(response.data));
    this.availableFields = this.availableFields.sort((a, b) => SortHelper.compareStrings(a.FieldName as string, b.FieldName as string));
    this.availableFields = this.availableFields.filter((x) => this.missionStore.availableMissions.some((y) => y.ReferenceFieldID == x.FieldID));
  }

  getMissionsForField(fieldId: string): SinglePathMission[] {
    const missions = this.missionStore.availableMissions.filter((x) => x.ReferenceFieldID == fieldId);
    return missions;
  }

  async machineAlarms() {
    router.push({ name: 'Alarm', params: { machineId: this.machineStore.machine?.machineId ?? '' } });
  }

  async monitorMission() {
    if (this.selectedDeployedMission != null) {
      this.missionStore.setDeployedMission(this.selectedDeployedMission);
      router.push({ name: 'MissionMonitoring' });
    }
  }

  async manualMode() {
    this.menuStore.setDrawer(false);
  }

  async checkMachineState(value: MachineKey) {
    this.menuStore.setLoadingMissions(true);
    try {
      this.machineStore.setSelectedMachine(value);
      if (value == null) {
        this.selectedItem = null;
        this.popState();
      } else {
        const machineId = this.machineStore.machine?.machineId.toString() as string;
        this.menuStore.pushMenuState('Machine-Selected');
        const update = this.machineUpdateAvailable(machineId);
        this.updateStore.changeCurrentMachine(update);
        if (this.flightPathService != null) {
          this.selectedMachineMissionStatus = null;

          await this.machineOnline(machineId);
          this.customerDeployedMissions = await this.getDeployedMissions();

          await this.getDeployedMission(machineId);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.menuStore.setLoadingMissions(false);
    }
  }

  private async getDeployedMission(machineId: string) {
    if (this.customerDeployedMissions.length > 0) {
      this.selectedDeployedMission = this.customerDeployedMissions.filter((value) => {
        return value.TargetMachine.machineId == machineId;
      })[0];
    } else {
      this.selectedDeployedMission = null;
    }

    if (this.flightPathService == null || this.selectedDeployedMission == null) return;
    const response = await this.flightPathService.getDeployedSinglePathMission(this.selectedDeployedMission.MissionDeploymentID, this.globalStore.accountId);

    if (response != null) {
      const json = JSON.stringify(response.data);
      this.selectedDeployedMission = DeployedSinglePathMission.toModel(json);
    } else {
      console.error('Failed to get mission details');
      return null;
    }
  }

  async selectMachine(value: MachineKey) {
    this.machineStore.setSelectedMachine(value);
    if (value == null) {
      this.selectedItem = null;
      this.popState();
    } else {
      this.menuStore.pushMenuState('Machine-Selected');
      router.push({ name: 'Home' }).catch(() => { /* ignore NavigationDuplicated */ });
    }
  }

  private async machineOnline(machineId: string) {
    if (this.flightPathService != null) {
      const machineStatusResponse = await this.flightPathService.getMachineStatus([machineId]);
      if (machineStatusResponse != null) {
        const json = JSON.stringify(machineStatusResponse.data);

        const cachedmachines = JSON.parse(json) as Array<MachineMarker>;
        if (cachedmachines.length > 0) {
          this.isOnline = cachedmachines[0].IsOnline;
        } else {
          this.isOnline = false;
        }
      }
    }
  }

  get isManual() {
    return this.selectedDeployedMission == null;
  }
  get isRunning() {
    if (!this.isOnline) return false;
    return this.selectedDeployedMission != null;
  }
  async selectMission() {
    const machineId = this.machineStore.machine?.machineId.toString() as string;
    await this.machineOnline(machineId);
    if (this.isOnline) {
      this.menuStore.pushMenuState('Select-Mission');
      await this.getMissions();
      this.getAvailableFields();
      this.drawerState = true;
    }
  }

  async selectMissionPlan(value: SinglePathMission | null) {
    if (this.flightPathService == null) return;
    if (value != null && this.missionStore.mission == value) {
      this.missionStore.selectMission(null);
    } else {
      if (value != null) {
        const response = await this.flightPathService.getMissionByMissionId(value?.MissionID, this.globalStore.accountId);
        value = SinglePathMission.toModel(JSON.stringify(response.data));
      }

      this.missionStore.selectMission(value);
      const implementKey = this.missionStore.currentApplicationParameters.get('implement_type') as string;
      this.selectedMissionType = implementKey == ImplementKeys.sprayer ? ImplementKeys.sprayer : ImplementKeys.tillage;
      this.selectedToolType = implementKey == ImplementKeys.sprayer ? ImplementKeys.sprayer : implementKey;
      this.speedKph = this.missionStore.selectedMission?.TargetSpeedKph as number;
      this.speedRpm = toNumber((this.missionStore.currentApplicationParameters.get(Parameters.engineSpeed) as string) ?? 0);
      this.vineWidth = toNumber(this.missionStore.currentApplicationParameters.get(Parameters.vineWidth) as string);
      this.volume = toNumber(this.missionStore.currentApplicationParameters.get(Parameters.volume) as string);
      this.sprayProduct = this.missionStore.currentApplicationParameters.get(Parameters.sprayProduct) as string;
      if (this.flightPathService != null) {
        const machineId = this.machineStore.machine?.machineId.toString();
        const response = await this.flightPathService.getMissionStatus(machineId as string);
        const status = ConvertMissionStatus.stringToMissionStatusModel(JSON.stringify(response.data));
        this.missionStore.setMissionStatus(status);
      }
    }
  }
  changeLocale(locale: string) {
    this.$i18n.locale = locale;
    this.$vuetify.lang.current = locale;
  }
  created(): void {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((pos) => {
        this.globalStore.updateCenterLocation({ lat: pos.coords.latitude, lng: pos.coords.longitude });
      });
    }
    this.flightPathService = container.get<FlightPathServiceInterface>(SERVICE_IDENTIFIER.FLIGHT_PATH);
    this.setupMqttActions();
  }

  private async setupMqttActions() {
    if (this.globalStore.accountId == '') {
      await this.updateAccountId();
    }
    this.addMqttVisibility(this.globalStore.alarmStatusTopic, () =>
      PubSub.subscribe(this.globalStore.alarmStatusTopic).subscribe({
        next: (data) => this.markerRecieved(data),
        error: (error) => this.mqttError(error)
      })
    );
    this.addMqttVisibility(this.globalStore.generalNotificationTopic, () =>
      PubSub.subscribe(this.globalStore.generalNotificationTopic).subscribe({
        next: (data) => this.notificationRecieved(data),
        error: (error) => this.mqttError(error)
      })
    );
    this.addMqttVisibility(this.globalStore.softwareUpdateTopic, () =>
      PubSub.subscribe(this.globalStore.softwareUpdateTopic).subscribe({
        next: (data) => this.softwareUpdateRecieved(data),
        error: (error) => this.mqttError(error)
      })
    );
  }

  private async updateAccountId() {
    try {
      const session = await Auth.currentSession();

      if (session != null) {
        const payload = session.getIdToken().payload;
        const accountId: string = payload['custom:accountid'];
        this.globalStore.updateAccountId(accountId);
      }
    } catch (error) {
      console.error(error);
    }
  }

  private setMqttSubscritions() {
    this.actions.forEach((act, key) => {
      this.subscriptions.set(key, act());
    });
  }

  async getAlarms() {
    if (this.flightPathService == undefined) {
      console.error('Service Undefined');
      return;
    } else {
      try {
        this.loadingAlarms = true;
        const user = await Auth.currentAuthenticatedUser();
        const machineKeys = await this.getCurrentMachineKeys();
        if (machineKeys.length > 0) {
          const response = await this.flightPathService.getAlarmTable(user.attributes.sub, JSON.stringify(machineKeys.map((tmp) => tmp.machineId)));
          const alarmModel = Convert.stringToAlarmModelList(JSON.stringify(response.data));
          alarmModel.forEach((alarm: AlarmModel) => {
            const index = machineKeys.findIndex((key) => key.machineId === alarm.MachineId);
            if (index == -1) {
              alarm.MachineName = 'None';
            } else {
              alarm.MachineName = machineKeys[index].MachineName ?? 'None';
            }
          });
          if (alarmModel != null) {
            this.alarmStore.changeAlarms(alarmModel);
          }
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.loadingAlarms = false;
      }
    }
  }

  async getCurrentMachineKeys(): Promise<MachineKey[]> {
    if (this.flightPathService == undefined) return [];

    const machineResponse = await this.flightPathService.getAvailableMachines();
    const currentMachines = ConvertMachineKey.toMachineKey(JSON.stringify(machineResponse.data));

    return currentMachines;
  }
  async getMissions() {
    if (this.flightPathService == undefined) return;
    this.menuStore.setLoadingMissions(true);
    this.missionStore.setAvailableMissions([]);

    try {
      const response = await this.flightPathService.getMissionsListByCustomerId(this.globalStore.accountId);
      const missions = SinglePathMission.toModelCollection(JSON.stringify(response.data));
      this.missionStore.setAvailableMissions(missions);
    } finally {
      this.menuStore.setLoadingMissions(false);
    }
  }

  async getImplements() {
    if (this.flightPathService == undefined) return;

    const response = await this.flightPathService.getAllImplements(this.globalStore.accountId);
    this.implements = ImplementOperationsModel.toModelCollection(JSON.stringify(response.data));
    // Add default implements for new accounts
    if (this.implements.length == 0) await this.addFakeImplements();
  }

  async addFakeImplements() {
    if (this.flightPathService == undefined) return;

    const fakeNoneString =
      '{"ErrorNotes":"","DistanceGPSToHitchX":0.0,"DistanceGPSToHitchY":0.0,"DistanceHitchToImplementCenterX":0.0,"DistanceHitchToImplementCenterY":0.0,"DistanceGPSToImplementCenterX":0.0,"DistanceGPSToImplementCenterY":-0.83,"DistanceGPSToTractorBackY":1.0,"LeftBuffer":0.5,"RightBuffer":0.5,"GPSOnTractor":false,"ThreePointHitch":false,"CreationTime":0,"NumberOfZones":1,"ImplementName":"none","ImplementID":"00000000-0000-0000-0000-000000000001","SectionMap":{},"MachineApproachDistanceMeters":"10","SwathBufferDistanceMeters":"1","WheelbaseMeters":"3","MaxSteeringAngleDegrees":"30","SectionControlConfiguration":{"ErrorNotes":"","OverlapThreshold":0.5,"Mode":"Threshold","LookAheadSecondsEntering":0.5,"LookAheadSecondsExiting":1.5,"SystemDelaySecondsEntering":0.5,"SystemDelaySecondsExiting":1.5,"DesiredOverlapMetersEntering":0,"DesiredOverlapMetersExiting":0,"MaxPopulation":1000,"MinPopulation":1,"GPSOffsetSeconds":1},"SectionList":[{"Item1":0,"Item2":0.0}],"SectionWidths":[1]}';
    const fakeDiscString =
      '{"ErrorNotes":"","DistanceGPSToHitchX":0.0,"DistanceGPSToHitchY":0.0,"DistanceHitchToImplementCenterX":0.0,"DistanceHitchToImplementCenterY":0.0,"DistanceGPSToImplementCenterX":0.0,"DistanceGPSToImplementCenterY":-0.83,"DistanceGPSToTractorBackY":1.0,"LeftBuffer":0.5,"RightBuffer":0.5,"GPSOnTractor":false,"ThreePointHitch":false,"CreationTime":0,"NumberOfZones":1,"ImplementName":"disc","ImplementID":"00000000-0000-0000-0000-000000000006","SectionMap":{},"MachineApproachDistanceMeters":"10","SwathBufferDistanceMeters":"1","WheelbaseMeters":"3","MaxSteeringAngleDegrees":"30","SectionControlConfiguration":{"ErrorNotes":"","OverlapThreshold":0.5,"Mode":"Threshold","LookAheadSecondsEntering":0.5,"LookAheadSecondsExiting":1.5,"SystemDelaySecondsEntering":0.5,"SystemDelaySecondsExiting":1.5,"DesiredOverlapMetersEntering":0,"DesiredOverlapMetersExiting":0,"MaxPopulation":1000,"MinPopulation":1,"GPSOffsetSeconds":1},"SectionList":[{"Item1":0,"Item2":0.0}],"SectionWidths":[1]}';
    const fakeBladeString =
      '{"ErrorNotes":"","DistanceGPSToHitchX":0.0,"DistanceGPSToHitchY":0.0,"DistanceHitchToImplementCenterX":0.0,"DistanceHitchToImplementCenterY":0.0,"DistanceGPSToImplementCenterX":0.0,"DistanceGPSToImplementCenterY":-0.83,"DistanceGPSToTractorBackY":1.0,"LeftBuffer":0.5,"RightBuffer":0.5,"GPSOnTractor":false,"ThreePointHitch":false,"CreationTime":0,"NumberOfZones":1,"ImplementName":"blade","ImplementID":"00000000-0000-0000-0000-000000000007","SectionMap":{},"MachineApproachDistanceMeters":"10","SwathBufferDistanceMeters":"1","WheelbaseMeters":"3","MaxSteeringAngleDegrees":"30","SectionControlConfiguration":{"ErrorNotes":"","OverlapThreshold":0.5,"Mode":"Threshold","LookAheadSecondsEntering":0.5,"LookAheadSecondsExiting":1.5,"SystemDelaySecondsEntering":0.5,"SystemDelaySecondsExiting":1.5,"DesiredOverlapMetersEntering":0,"DesiredOverlapMetersExiting":0,"MaxPopulation":1000,"MinPopulation":1,"GPSOffsetSeconds":1},"SectionList":[{"Item1":0,"Item2":0.0}],"SectionWidths":[1]}';
    const fakeMowerString =
      '{"ErrorNotes":"","DistanceGPSToHitchX":0.0,"DistanceGPSToHitchY":0.0,"DistanceHitchToImplementCenterX":0.0,"DistanceHitchToImplementCenterY":0.0,"DistanceGPSToImplementCenterX":0.0,"DistanceGPSToImplementCenterY":-0.83,"DistanceGPSToTractorBackY":1.0,"LeftBuffer":0.5,"RightBuffer":0.5,"GPSOnTractor":false,"ThreePointHitch":false,"CreationTime":0,"NumberOfZones":1,"ImplementName":"mower","ImplementID":"00000000-0000-0000-0000-000000000008","SectionMap":{},"MachineApproachDistanceMeters":"10","SwathBufferDistanceMeters":"1","WheelbaseMeters":"3","MaxSteeringAngleDegrees":"30","SectionControlConfiguration":{"ErrorNotes":"","OverlapThreshold":0.5,"Mode":"Threshold","LookAheadSecondsEntering":0.5,"LookAheadSecondsExiting":1.5,"SystemDelaySecondsEntering":0.5,"SystemDelaySecondsExiting":1.5,"DesiredOverlapMetersEntering":0,"DesiredOverlapMetersExiting":0,"MaxPopulation":1000,"MinPopulation":1,"GPSOffsetSeconds":1},"SectionList":[{"Item1":0,"Item2":0.0}],"SectionWidths":[1]}';
    const fakePloughString =
      '{"ErrorNotes":"","DistanceGPSToHitchX":0.0,"DistanceGPSToHitchY":0.0,"DistanceHitchToImplementCenterX":0.0,"DistanceHitchToImplementCenterY":0.0,"DistanceGPSToImplementCenterX":0.0,"DistanceGPSToImplementCenterY":-0.83,"DistanceGPSToTractorBackY":1.0,"LeftBuffer":0.5,"RightBuffer":0.5,"GPSOnTractor":false,"ThreePointHitch":false,"CreationTime":0,"NumberOfZones":1,"ImplementName":"plough","ImplementID":"00000000-0000-0000-0000-000000000010","SectionMap":{},"MachineApproachDistanceMeters":"10","SwathBufferDistanceMeters":"1","WheelbaseMeters":"3","MaxSteeringAngleDegrees":"30","SectionControlConfiguration":{"ErrorNotes":"","OverlapThreshold":0.5,"Mode":"Threshold","LookAheadSecondsEntering":0.5,"LookAheadSecondsExiting":1.5,"SystemDelaySecondsEntering":0.5,"SystemDelaySecondsExiting":1.5,"DesiredOverlapMetersEntering":0,"DesiredOverlapMetersExiting":0,"MaxPopulation":1000,"MinPopulation":1,"GPSOffsetSeconds":1},"SectionList":[{"Item1":0,"Item2":0.0}],"SectionWidths":[1]}';
    const fakeSprayerString =
      '{"ErrorNotes":"","DistanceGPSToHitchX":0.0,"DistanceGPSToHitchY":0.0,"DistanceHitchToImplementCenterX":0.0,"DistanceHitchToImplementCenterY":0.0,"DistanceGPSToImplementCenterX":0.0,"DistanceGPSToImplementCenterY":-0.83,"DistanceGPSToTractorBackY":1.0,"LeftBuffer":0.5,"RightBuffer":0.5,"GPSOnTractor":false,"ThreePointHitch":false,"CreationTime":0,"NumberOfZones":1,"ImplementName":"sprayer","ImplementID":"00000000-0000-0000-0000-000000000009","SectionMap":{},"MachineApproachDistanceMeters":"10","SwathBufferDistanceMeters":"1","WheelbaseMeters":"3","MaxSteeringAngleDegrees":"30","SectionControlConfiguration":{"ErrorNotes":"","OverlapThreshold":0.5,"Mode":"Threshold","LookAheadSecondsEntering":0.5,"LookAheadSecondsExiting":1.5,"SystemDelaySecondsEntering":0.5,"SystemDelaySecondsExiting":1.5,"DesiredOverlapMetersEntering":0,"DesiredOverlapMetersExiting":0,"MaxPopulation":1000,"MinPopulation":1,"GPSOffsetSeconds":1},"SectionList":[{"Item1":0,"Item2":0.0}],"SectionWidths":[1]}';

    const fakeNoneImplement: ImplementOperationsModel = ImplementOperationsModel.toModel(fakeNoneString);
    const fakeDiscImplement: ImplementOperationsModel = ImplementOperationsModel.toModel(fakeDiscString);
    const fakeBladeImplement: ImplementOperationsModel = ImplementOperationsModel.toModel(fakeBladeString);
    const fakeMowerImplement: ImplementOperationsModel = ImplementOperationsModel.toModel(fakeMowerString);
    const fakePloughImplement: ImplementOperationsModel = ImplementOperationsModel.toModel(fakePloughString);
    const fakeSprayerImplement: ImplementOperationsModel = ImplementOperationsModel.toModel(fakeSprayerString);

    // assign new implement IDs so that existing implements don't get overwritten with a new account id
    fakeNoneImplement.ImplementID = Guid.create().toString();
    fakeDiscImplement.ImplementID = Guid.create().toString();
    fakeBladeImplement.ImplementID = Guid.create().toString();
    fakeMowerImplement.ImplementID = Guid.create().toString();
    fakePloughImplement.ImplementID = Guid.create().toString();
    fakeSprayerImplement.ImplementID = Guid.create().toString();

    await this.flightPathService.addImplement(fakeNoneImplement, this.globalStore.accountId);
    await this.flightPathService.addImplement(fakeDiscImplement, this.globalStore.accountId);
    await this.flightPathService.addImplement(fakeBladeImplement, this.globalStore.accountId);
    await this.flightPathService.addImplement(fakeMowerImplement, this.globalStore.accountId);
    await this.flightPathService.addImplement(fakePloughImplement, this.globalStore.accountId);
    await this.flightPathService.addImplement(fakeSprayerImplement, this.globalStore.accountId);

    // Reload implements after creating them
    const response = await this.flightPathService.getAllImplements(this.globalStore.accountId);
    this.implements = ImplementOperationsModel.toModelCollection(JSON.stringify(response.data));
  }

  get availableToolTypes() {
    // only get tool types (implementts) that are currently in the database
    return this.toolTypes.filter(
      (x) =>
        x.value != ImplementKeys.weeder && x.value != ImplementKeys.sprayer && this.implements.findIndex((implement) => implement.ImplementName == x.value) > -1
    );
  }

  /**
   * used for testing
   */
  mapPoints(points: Point[]): GPSLocation[] {
    return points.map((val) => ({
      Latitude: val.Item1,
      Longitude: val.Item2,
      Elevation: 0,
      Bearing: 0,
      Speed: 0,
      TimeStamp: ''
    }));
  }

  closeParamsDialog() {
    this.paramDialog = false;
    this.editParam = true;
    this.missionStore.editMission(false);
    if (this.missionStore.selectedMission != null) {
      this.speedKph = this.missionStore.selectedMission.TargetSpeedKph;
      this.speedRpm = toNumber((this.missionStore.currentApplicationParameters.get(Parameters.engineSpeed) as string) ?? 0);
      const implementKey = this.missionStore.currentApplicationParameters.get('implement_type') as string;
      this.selectedMissionType = implementKey == ImplementKeys.sprayer ? ImplementKeys.sprayer : ImplementKeys.tillage;
      this.selectedToolType = implementKey == ImplementKeys.sprayer ? ImplementKeys.sprayer : implementKey;
      this.vineWidth = toNumber(this.missionStore.currentApplicationParameters.get(Parameters.vineWidth) as string);
      this.volume = toNumber(this.missionStore.currentApplicationParameters.get(Parameters.volume) as string);
    }
  }

  get implementType() {
    if (this.selectedMissionType == ImplementKeys.sprayer) {
      return ImplementKeys.sprayer;
    } else {
      return this.selectedToolType;
    }
  }

  get isSprayingMission(): boolean {
    return (this.missionStore.applicationParameters.get(Parameters.implementType) as string) == ImplementKeys.sprayer;
  }

  async saveParams(event: any) {
    event.preventDefault();
    if (this.flightPathService == undefined) return;

    // set the implement name in the application parameters of the mission
    const params = this.missionStore.currentApplicationParameters;
    params.set(Parameters.engineSpeed, this.speedRpm.toString());
    params.set(Parameters.implementType, this.implementType);
    if (this.selectedMissionType == ImplementKeys.sprayer) {
      params.set(Parameters.vineWidth, this.vineWidth.toString());
      params.set(Parameters.volume, this.volume.toString());
    }

    this.missionStore.setApplicationParameters(params);
    const mission = (this.missionStore.selectedMission as SinglePathMission).setApplicationParameters(params);
    mission.TargetSpeedKph = this.speedKph;

    // update the implement id directly within the mission as well
    const selectedImplement = this.implements.find((x) => x.ImplementName == this.implementType);
    if (selectedImplement != undefined) {
      mission.ImplementCode = selectedImplement.ImplementID;
    }

    this.closeParamsDialog();
    //await this.flightPathService.insertOrUpdateMission(mission);
  }

  async mounted() {
    if (this.flightPathService != undefined) await this.flightPathService.updateToken();
    this.warmUpLambdas();
    this.loadingAlarms = false;
    this.setupSession();
    this.getAlarms();
    this.setMqttSubscritions();
    this.getImplements();
    await this.updateLastUpdated();
    this.setMenu();
    await this.setWakeLock();
    // warm lambdas every 5 minutes
    this.warmLambdaInterval = window.setInterval(this.warmUpLambdas, 300000);
  }

  async setWakeLock() {
    // eslint-disable-next-line no-undef
    if ('wakeLock' in (navigator as NavigatorExtended)) this.isWakeLockSupported = true;
    else {
      console.info('WakeLock API Not Available');
    }
    try {
      // eslint-disable-next-line no-undef
      this.wakeLock = await (navigator as NavigatorExtended).wakeLock.request('screen');
    } catch (err) {
      // The Wake Lock request has failed - usually system related, such as battery.
      console.error(err);
    }
  }
  destroyed() {
    this.removeMqttVisibility();
    if (this.isWakeLockSupported && this.wakeLock != null) this.wakeLock?.release();
    clearInterval(this.warmLambdaInterval);
  }

  private async updateLastUpdated() {
    if (this.flightPathService == undefined) return;
    const response = await this.flightPathService.getEntityLastModified(this.globalStore.accountId, EntitesList);
    const json = JSON.stringify(response.data);
    const updatedTimes = JSON.parse(json) as Entities;

    const fieldDate = new Date(updatedTimes.Field);
    const pathDate = new Date(updatedTimes.SimplePath);
    const missionDate = new Date(updatedTimes.DeployedSinglePathMission);

    this.UpdateNotifyIndications(fieldDate, pathDate, missionDate);

    this.$forceUpdate();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private markerRecieved(data: any): void {
    if (this.loadingAlarms == true) {
      console.info('Alarms Loading... Not Recieved', data.value);
      return;
    }
    this.getAlarms();
  }

  private notificationRecieved(data: any): void {
    const response = data.value as string;
    const status = GenericNotifyConvert.toGenericNotification(JSON.stringify(response));
    this.notificationStore.updateCounterNotification({ Type: status.Type.toString(), Value: true });
    this.notificationStore.incrementCount(status.Type);
    this.setMenu();
    if (!this.canViewManagerMenu) return;
    this.processNotification(status);
  }

  private softwareUpdateRecieved(data: any): void {
    if (router.currentRoute.name != 'Home' || this.updateDialog) return;
    const response = data.value as string;
    const status = MachineSWUpdateData.toModel(JSON.stringify(response));
    this.updateStore.addUpdate(status);
    if (this.updateStore.deferredUpdates.some((o) => o == status.machine_id)) return;
    if (status.software_update_state == MachineSoftwareUpdateState.WAITING_FOR_USER_CONFIRMATION) {
      this.updateMachine(status);
    }
  }

  updateMachine(status: MachineSWUpdateData) {
    this.updateDialog = true;
    this.updateStore.changeCurrentMachine(status);
  }
  async closeUpdateDialog() {
    this.updateDialog = false;
    const updateState = this.updateStore.currentMachineUpdate?.available_update_status ?? AvailableUpdateStatus.UNKNOWN;

    this.updateStore.addDeferred(this.updateStore.currentMachineUpdate?.machine_id as string);

    const uiPayload = this.createUIUpdatePayload(
      updateState == AvailableUpdateStatus.MANDATORY ? UserProceedWithUpdateResponse.NO : UserProceedWithUpdateResponse.DEFER,
      this.updateStore.currentMachineUpdate as MachineSWUpdateData
    );
    this.lastUIUpdate = uiPayload;
    await this.publishUIPayload(uiPayload);
  }

  async submitUpdate() {
    this.updateDialog = false;
    const uiPayload = this.createUIUpdatePayload(UserProceedWithUpdateResponse.YES, this.updateStore.currentMachineUpdate as MachineSWUpdateData);
    this.lastUIUpdate = uiPayload;
    await this.publishUIPayload(uiPayload);
    router.push({ name: 'SoftwareUpdate' });
  }

  setMenu() {
    this.items = [
      { title: this.$t('menu.home'), icon: 'mdi-home', route: { name: 'Home' }, visible: true, subItems: [], newItems: () => false },
      {
        title: this.$t('menu.missions'),
        icon: 'mdi-format-list-bulleted',
        route: null,
        visible: this.canViewOperatorMenu,
        newItems: () =>
          this.notificationStore.newInProgressMissionItems ||
          this.notificationStore.newCancelledMissionItems ||
          this.notificationStore.newCompletedMissionItems,
        subItems: [
          {
            title: this.$t('menu.missions-in_progress'),
            icon: '',
            route: { name: 'InProgressMissions' },
            newItems: () => this.notificationStore.newInProgressMissionItems
          },
          {
            title: this.$t('menu.missions-completed'),
            icon: '',
            route: { name: 'CompletedMissions' },
            newItems: () => this.notificationStore.newCompletedMissionItems || this.notificationStore.newCancelledMissionItems
          },
          { title: this.$t('menu.missions-add_edit'), icon: '', route: { name: 'AddAndEditMissions' }, newItems: () => false }
        ]
      },
      {
        title: this.$t('menu.fields_paths'),
        icon: 'mdi-image-filter-hdr',
        route: null,
        visible: this.canViewOperatorMenu,
        newItems: () => this.notificationStore.newFieldItems || this.notificationStore.newPathItems,
        subItems: [
          { title: this.$t('menu.fields_paths-fields'), icon: '', route: { name: 'Fields' }, newItems: () => this.notificationStore.newFieldItems },
          { title: this.$t('menu.fields_paths-paths'), icon: '', route: { name: 'Paths' }, newItems: () => this.notificationStore.newPathItems }
        ]
      },
      {
        title: this.$t('menu.users'),
        icon: 'mdi-account-multiple',
        route: { name: 'Users' },
        visible: this.canViewManagerMenu,
        newItems: () => false,
        subItems: []
      },
      {
        title: this.$t('menu.userguide'),
        icon: 'mdi-book-open-variant-outline',
        route: { name: 'UserGuide' },
        visible: this.canViewSetMenu,
        newItems: () => false,
        subItems: []
      }
    ];
  }

  get canViewManagerMenu() {
    return this.$vuetify.breakpoint.mdAndUp && this.allowManagerViews;
  }
  get canViewOperatorMenu() {
    return this.$vuetify.breakpoint.mdAndUp && this.allowOperatorViews;
  }
  get canViewSetMenu() {
    return this.$vuetify.breakpoint.mdAndUp;
  }
  async beforeCreate() {
    Hub.listen('auth', (data) => {
      console.log('data:', data);
      const { payload } = data;
      switch (payload.event) {
        case 'signIn':
          console.info('user signed in');
          this.signedIn = true;
          this.$router.push('/home');
          this.setupSession();

          if (this.actions.size == 0) {
            this.setupMqttActions();
            this.setMqttSubscritions();
          }

          break;
        case 'signOut':
          console.info('user signed out');
          this.$router.push('/auth');
          this.signedIn = false;
          this.userInfo = null;
          this.allowManagerViews = false;
          this.setMenu();
          this.globalStore.updateAccountId('');
          this.removeMqttVisibility();
          break;
        case 'signIn_failure':
          this.signedIn = false;
          this.userInfo = null;
          this.allowManagerViews = false;
          this.setMenu();
          break;
        case 'tokenRefresh':
          console.info('token refresh succeeded');
          break;
        case 'tokenRefresh_failure':
          console.error('token refresh failed');
          break;
      }
    });

    Auth.currentSession()
      .then((session) => {
        const payload = session.getIdToken().payload;
        const accountId: string = payload['custom:accountid'];
        this.globalStore.updateAccountId(accountId);
      })
      .catch((err) => {
        this.signedIn = false;
        console.error(err);
      });
  }

  private setupSession() {
    Auth.currentAuthenticatedUser()
      .then((user) => {
        this.signedIn = true;
        this.user = user;
      })
      .catch(() => (this.signedIn = false));

    Auth.currentUserInfo()
      .then((res) => {
        if (res != null) this.userInfo = res?.attributes;
      })
      .catch((err) => {
        this.signedIn = false;
        console.error(err);
      });

    Auth.currentSession()
      .then((session) => {
        const payload = session.getIdToken().payload;
        const groups: Array<string> = payload['cognito:groups'];
        
        if (groups.includes(Group.Managers) || groups.includes(Group.Admins)
          || groups.includes(Group.AccountOwner) || groups.includes(Group.FlightPathAdmin)) {
          this.allowManagerViews = true;
          this.allowOperatorViews = true;
          this.setMenu();
        }else if(groups.includes(Group.Operators) || groups.includes(Group.Planners)
          || groups.includes(Group.Users)) {
          this.allowManagerViews = false;
          this.allowOperatorViews = true;
          this.setMenu();
        }
        const accountId: string = payload['custom:accountid'];
        this.globalStore.updateAccountId(accountId);
      })
      .catch((err) => {
        this.signedIn = false;
        console.error(err);
      });
  }
}
